import {ModuleWithProviders, NgModule} from '@angular/core';
import {TitleService, Logger, ApiService, ScreenService, JwtService, LocalStorageService} from './services';
import {LoggerConfig, LoggerLevel} from './services';
import {JwtHelper} from 'angular2-jwt';
import {
    API_CONFIG, ApiConfig, AppConfig, LocaleConfig, DataChangesObserver,
    LocaleTranlationsLoader, MetaTranslationResolver
} from './utils';
import {MouseDownPreventDefaultDirective, SwipeScrollDirective} from './directives';
import {CapitalizeFirstPipe, FormatDatePipe, ReplacePipe, TruncatePipe} from './pipes';

@NgModule({
    exports: [
        CapitalizeFirstPipe,
        FormatDatePipe,
        ReplacePipe,
        TruncatePipe,
        SwipeScrollDirective,
        MouseDownPreventDefaultDirective,
    ],
    declarations: [
        CapitalizeFirstPipe,
        FormatDatePipe,
        ReplacePipe,
        TruncatePipe,
        SwipeScrollDirective,
        MouseDownPreventDefaultDirective,
    ],
    providers: [
        TitleService,
        ApiService,
        JwtHelper,
        JwtService,
        LocalStorageService,
        ScreenService,
        LocaleTranlationsLoader,
        MetaTranslationResolver,
        DataChangesObserver,
        Logger
    ]
})
export class AppCommonModule {

    static forRoot(options: AppConfig) {

        return {
            ngModule: AppCommonModule,
            providers: [
                TitleService,
                ApiService,
                JwtHelper,
                JwtService,
                LocalStorageService,
                ScreenService,
                LocaleTranlationsLoader,
                MetaTranslationResolver,
                DataChangesObserver,
                Logger,
                {
                    provide: LoggerConfig,
                    useValue: {
                        level: ((options && options.logLevel) ? options.logLevel : LoggerLevel.WARN)
                    }
                },
                {
                    provide: ApiConfig,
                    useValue: options.apiConfig
                },
                {
                    provide: LocaleConfig,
                    useValue: options.localeConfig
                }
            ]
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/common/common-module.ts